// extracted by mini-css-extract-plugin
module.exports = {"top_image":"iHq2oS"};